import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { format } from 'date-fns';
import { getTherapistFiltersAction } from 'src/redux/actions/documentBundleActions';
import { TherapistOption } from '../by-cohort/types';

/**
 * SQ-171: therapists with documents in the window.
 *
 * Scoped to the dates, so the control can never offer a name that matches nothing — the
 * failure the static Discipline and Document type lists still have (D8).
 */
export function useTherapistOptions(dateFrom: Date, dateTo: Date) {
  const dispatch = useDispatch();
  const { response, loading } = useSelector((state: any) => state.getTherapistFiltersReducer);

  const from = format(dateFrom, 'yyyy-MM-dd');
  const to = format(dateTo, 'yyyy-MM-dd');

  useEffect(() => {
    dispatch(getTherapistFiltersAction({ date_from: from, date_to: to }));
  }, [from, to, dispatch]);

  const therapists: TherapistOption[] = useMemo(() => response?.therapists ?? [], [response]);

  return { therapists, loading };
}
